import React from 'react';
import styled from 'styled-components';
import { Alert } from '../Alert/Alert';
import { focarCampo } from '../../../utils/destaqueCampos';

// Labels de checkbox/documentos costumam ser frases inteiras; na pílula só cabe o começo.
const LIMITE_LABEL = 45;

const resumir = (label) => (
  label.length > LIMITE_LABEL ? `${label.slice(0, LIMITE_LABEL).trimEnd()}…` : label
);

const Lista = styled.span`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.5rem;
  margin-top: 0.35rem;
`;

const Pilula = styled.button`
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid currentColor;
  border-radius: 20px;
  padding: 0.15rem 0.7rem;
  font-size: 0.8rem;
  line-height: 1.4;
  color: inherit;
  cursor: pointer;
  max-width: 100%;
  text-align: left;
  overflow-wrap: anywhere;
  transition: background 0.2s ease;

  &:hover,
  &:focus-visible {
    background: white;
    outline: none;
  }
`;

/**
 * Aviso "Revise N itens" com uma pílula por pendência; clicar leva até o item
 * (wrapper com data-field-name={id}, ver utils/destaqueCampos.js).
 *
 * @param {Array<{id: string, label: string, detalhe?: string}>} props.itens
 * @param {string} [props.singular='campo'] / [props.plural='campos'] - substantivo do título
 */
export const ResumoPendencias = ({ itens, singular = 'campo', plural = 'campos', onClose, ...props }) => {
  if (!itens?.length) return null;

  const total = itens.length;
  const titulo = total === 1
    ? `Revise 1 ${singular} antes de continuar`
    : `Revise ${total} ${plural} antes de continuar`;

  return (
    <Alert
      type="error"
      role="alert"
      title={titulo}
      message={
        <Lista>
          {itens.map(item => (
            <Pilula
              key={item.id}
              type="button"
              title={item.detalhe || item.label}
              onClick={() => focarCampo(item.id)}
            >
              {resumir(item.label)}
            </Pilula>
          ))}
        </Lista>
      }
      onClose={onClose}
      {...props}
    />
  );
};
